import { render } from "./RecoverPass.vue?vue&type=template&id=1b3b084c&scoped=true&ts=true"
import script from "./RecoverPass.vue?vue&type=script&lang=ts"
export * from "./RecoverPass.vue?vue&type=script&lang=ts"

import "./login.css?vue&type=style&index=0&id=1b3b084c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3b084c"]])

export default __exports__